module.exports = __webpack_public_path__ + "static/media/Neo-Bank-App-02.96e52c9c.png";